import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { Button } from '../../common/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: ${theme.colors.background};
  padding: ${theme.spacing.md};
  text-align: center;
`;

const SuccessMessage = styled.h1`
  font-family: ${theme.typography.headingFont};
  font-size: ${theme.typography.fontSizes.xlarge};
  color: ${theme.colors.deepNavy};
  margin-bottom: ${theme.spacing.lg};
`;

const SharingSuccessScreen = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <SuccessMessage>Your impact has been shared!</SuccessMessage>
      <Button primary onClick={() => navigate('/')}>
        Back to Home
      </Button>
    </Container>
  );
};

export default SharingSuccessScreen;
